var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"text-center"},_vm._l((_vm.videos),function(video){return _c('v-col',{key:video.id,attrs:{"cols":"12"}},[_c('jazz-video',{attrs:{"video":video}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }